import { connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import createStorybookListener from 'storybook-addon-redux-listener';

// Import the state interface and our combined reducers/sagas.
import { rootReducer, rootSaga } from './store';

export default function configureStore(history, initialState) {
  const reduxListener = [];
  // create the composing function for our middlewares
  const composeEnhancers = composeWithDevTools({});
  // create the redux-saga middleware
  const sagaMiddleware = createSagaMiddleware();

  if (process.env.NODE_ENV === 'storybook') {
    reduxListener.push(createStorybookListener());
  }

  // We'll create our store with the combined reducers/sagas, and the initial Redux state that
  // we'll be passing from our entry point.
  const store = createStore(
    connectRouter(history)(rootReducer),
    initialState,
    composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware, ...reduxListener))
  );

  // Don't forget to run the root saga, and return the store object.
  sagaMiddleware.run(rootSaga);
  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js